import { useState } from "react";

import PrimaryButton from "../buttons/PrimaryButton";
import { useAppContext } from "../config/AppContext";
import { signInAsGuest } from "../auth/FirebaseAuth";
import ReCAPTCHA from "react-google-recaptcha";
import { useSnackbar } from "notistack";
import SmallSpinner from "../loading/SmallSpinner";

const RecaptchaComponent = ({
  email,
  iframe,
  actionText = "Valider",
  handleSuccess,
  mobile = false,
}) => {
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [captchaToken, setCaptchaToken] = useState(null);
  const RECAPTCHA_SITE_KEY = "6LfaqgErAAAAAElOWIkaMesulgq0chp-pTODwhKN";
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!appState.dev && !captchaToken) {
      handleClickVariant("Merci de compléter le captcha", "error");
      return;
    }

    // Send token to backend with the rest of the form
    let res = await fetch(
      prefix + (appState.dev ? "auth/captcha/test" : "auth/captcha/check"),
      {
        method: "POST",
        body: JSON.stringify({
          token: captchaToken,
          master_id: iframe.master_id,
          email: email,
        }),
        headers: { "Content-Type": "application/json" },
      }
    );
    let response = await res.json();
    if (response.success) {
      let token = response.token;
      await signInAsGuest(token);
      handleSuccess();
    } else {
      handleClickVariant("Captcha invalide", "error");
    }
    setLoading(false);
  };

  return (
    <div className="flex flex-col gap-4">
      <ReCAPTCHA
        sitekey={RECAPTCHA_SITE_KEY}
        onChange={(token) => setCaptchaToken(token)}
      />
      <PrimaryButton
        disabled={loading}
        className={"w-fit"}
        onClick={handleSubmit}
        mobile={mobile}
        big={true}
      >
        {actionText}
        <SmallSpinner loading={loading} />
      </PrimaryButton>
    </div>
  );
};
export default RecaptchaComponent;
